export default __webpack_public_path__ + "static/media/seshLogo.8b44b617.png";